import { BrandsId } from '@containers/ProductDetailContainer/ProductDetail/model';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetail/ProductDetailContext';

export const useBrand = () => {
  const {
    product: {
      brand: { id: brandId },
    },
  } = useProductDetailContext();

  const isLaRoche = String(brandId) === BrandsId.Roche;
  const isEstee = String(brandId) === BrandsId.Estee;

  return { isLaRoche, isEstee };
};
